// extracted by mini-css-extract-plugin
export var currencyInput = "_k4-1";
export var currencySymbol = "_k4-0";